import { Col, Row, Text } from 'components';
import { normalizeDate, theme } from 'lib';
import { useState } from 'react';
import styled from 'styled-components';
import { ImageModal, ImageMsg } from './';

const Container = styled.div`
  flex-direction: row;
  ${(props) => props.selfMessage && `flex-direction: row-reverse;`};
  width: 100%;
`;

const MessageChunk = ({ item, user }) => {
  const [imageVisible, setImageVisible] = useState(null);

  if (!item.length) return null;
  const selfMessage = item[0].sender === user._id;

  return (
    <Container selfMessage={selfMessage}>
      <ImageModal visible={imageVisible} closeModal={() => setImageVisible(null)} />

      <Col endHorizontal={selfMessage} startAll={!selfMessage} noFlex marg="8px 0 0">
        {item.map((x, i) => {
          const lastItem = i === 0,
            firstItem = i === item.length - 1;

          return (
            <Row
              key={i}
              pos="relative"
              start
              minWid="140px"
              wid="fit-content"
              pad={x.file ? '8px 8px 10px' : '10px 16px'}
              marg="8px 0 0"
              bg={selfMessage ? theme.FOG : theme.GREY_10}
              between
              individualRadius={
                selfMessage
                  ? ['22px', lastItem ? '22px' : '0', '0', '22px']
                  : ['0', '22px', '22px', firstItem ? '22px' : '0']
              }
            >
              {x.file ? (
                <ImageMsg file={x.file} isSender={selfMessage} setImageVisible={setImageVisible} />
              ) : (
                <Row maxWid="420px">
                  <Text b1 med marg="0 0 10px" wordBreak="break-word">
                    {x.body}
                  </Text>
                </Row>
              )}

              <Row pos="absolute" absolute noFlex right={x.file ? '8px' : '16px'} bottom="4px">
                <Text b2 med col={theme.GREY_70}>
                  {normalizeDate(x.createdAt, 'Hour')}
                </Text>
              </Row>
            </Row>
          );
        })}
      </Col>
    </Container>
  );
};

export default MessageChunk;
